import React from "react";
import { TwoToneIconT } from "types/utils";

const StatusIconCurrent = ({
  accentColor = "var(--diamond-blue)",
  mainColor = "var(--white)",
  size = "48",
  containerStyles,
}: TwoToneIconT) => {
  return (
    <div
      style={{
        // paddingTop: "3px",
        lineHeight: "10px",
        ...containerStyles,
      }}
    >
      <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="24" cy="24" r="24" fill={accentColor} />
        <circle cx="24" cy="24" r="18" fill={mainColor} />
      </svg>
    </div>
  );
};

export default StatusIconCurrent;
